module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container section"
  }, [_c('div', {
    staticClass: "row heading"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h2', [_vm._v(_vm._s(_vm.label) + " Cashflow ")])]), _vm._v(" "), _c('div', {
    staticClass: "col text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.saveToDashboard()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v("  Save To Dashboard")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loader-holder"
  }, [_c('loading', {
    attrs: {
      "color": "#5e9cd3"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col chart-col"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col dashboard-section"
  }, [_c('label', [_vm._v("Total Lifetime Cashflow")]), _vm._v(" "), _c('div', {
    staticClass: "display text-center"
  }, [_c('span', {
    staticClass: "displayNum"
  }, [_vm._v("$" + _vm._s(_vm._f("formatMoney")(_vm.value)))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col ledger-col"
  }, [_c('div', {
    staticClass: "row lined head"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 text-right"
  }, [_c('span', {
    staticClass: "col-form-label pagination-description"
  }, [_vm._v("\n              " + _vm._s(this.paginate.current_page) + " of " + _vm._s(this.paginate.num_pages) + " pages\n            ")]), _vm._v(" "), _c('paginate', {
    attrs: {
      "page-count": _vm.paginate.num_pages,
      "initial-page": _vm.paginate.current_page - 1,
      "page-range": 3,
      "margin-pages": 1,
      "click-handler": _vm.paginateClick,
      "container-class": "pagination",
      "page-class": "page-item",
      "page-link-class": "page-link",
      "prev-class": "page-item",
      "prev-link-class": "page-link",
      "next-class": "page-item",
      "next-link-class": "page-link"
    }
  })], 1)]), _vm._v(" "), _vm._l((_vm.cashflowTransactions), function(line) {
    return _c('div', {
      staticClass: "row lined",
      class: [(line.amount < 0) ? 'text-danger' : '']
    }, [_c('div', {
      staticClass: "col"
    }, [_vm._v("\n                    " + _vm._s(_vm._f("formatDate")(line.date_posted)) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "col"
    }, [_vm._v("\n                    " + _vm._s(line.description) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "col text-right"
    }, [_vm._v("\n                    $" + _vm._s(line.amount) + "\n                ")])])
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row "
  }, [_c('div', {
    staticClass: "col dashboard-section"
  }, [_c('label', [_vm._v("Cash Flow Trends")]), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "chart"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-form-label"
  }, [_c('h5', [_vm._v("Transactions")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1378dabe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/assets/Cashflow.vue
// module id = 359
// module chunks = 0